<template>
  <div class="main-content" :class="centerLayoutClass">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

import { useGlobalStore } from '@/stores/globalStore';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';

const store = useGlobalStore();
const orderStore = useOrderFormStore();
const centerLayoutClass = computed(() => {
  if (store.getIsBanxaNative) {
    return 'banxa-native';
  }
  if (orderStore.isNFTMode) {
    return 'nft-layout';
  }
  return '';
});
</script>

<style lang="scss">
.main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  overflow: auto;
  flex: 1;

  > .form {
    padding: 0 2rem;

    @include breakpoint($max-m) {
      height: 100%;
      form {
        height: 100%;
        // TODO: Create a wrapper so that this supports multiple buttons
        button{
          margin-top: auto;
        }
      }
    }
  }

  > div:not(.footer):not(.powered-footer) {
      margin-top: 2.4rem;
      padding: 0 2rem;
  }

  @include breakpoint($min-m) {
    background: var(--input-background);
    > div:not(.footer):not(.powered-footer) {
      padding: 6.4rem 2rem 0 2rem;
    }
  }

  & .settings-btn {
    display: none;
    padding: var(--padding-1);

    @include breakpoint($min-m) {
      display: block;
    }
  }

  &.banxa-native {
    background: none;

    > .form {
      padding-top: 0;

      @include breakpoint($min-m) {
        padding-bottom: 1em;
      }
    }

    @include breakpoint($min-m) {
      > div:not(.footer):not(.powered-footer) {
        margin-bottom: 0;
      }
    }

    & .settings-btn {
      display: none;
    }
  }

  &.nft-layout {
    background: none;

    > .form {
      padding-top: 0;

      @include breakpoint($min-m) {
        padding-bottom: 1em;
      }
    }

    @include breakpoint($min-m) {
      > div:not(.footer):not(.powered-footer) {
        margin-top: 1rem;
        margin-bottom: 0;
      }
    }

    & .settings-btn {
      display: none;
    }
  }
}
</style>
